module.exports = "/images/Germany.png?5bba8626b4c2f524c262bf679d597fdf";